/**
 * Follow-up Atoms - State management for Follow-ups
 *
 * Follow-ups = Active instances of agents following patients
 * Stored in follow_ups table with agent snapshots
 *
 * NO LOCAL TYPES - All types come from @/isomorphic/schemas
 *
 * NOTE: All action functions have been moved to actions/follow-up-actions.ts
 * This file now only contains atom definitions (state)
 */

import { atom } from "jotai";
import type { FollowUp, FollowUpListItem, FollowUpWithPatient } from "@/isomorphic/schemas";
import type { AtomStatus, AtomError } from "@/frontend/types/atoms";

// ============================================================================
// WORKSPACE FOLLOW-UPS ATOMS (for Dashboard)
// ============================================================================

/**
 * Internal atom: Workspace follow-ups (from API)
 * Used for dashboard display
 */
export const _apiWorkspaceFollowUpsAtom = atom<FollowUpListItem[]>([]);

export const workspaceFollowUpsStatusAtom = atom<AtomStatus>("init");
export const workspaceFollowUpsErrorAtom = atom<AtomError>(null);

/**
 * Public atom: Workspace follow-ups
 */
export const workspaceFollowUpsAtom = atom<FollowUpListItem[]>((get) => {
  return get(_apiWorkspaceFollowUpsAtom);
});

// ============================================================================
// PATIENT FOLLOW-UPS ATOMS
// ============================================================================

/**
 * Internal atom: Patient follow-ups (from API)
 * Exported for use in action functions
 */
export const _apiPatientFollowUpsAtom = atom<FollowUp[]>([]);

export const patientFollowUpsStatusAtom = atom<AtomStatus>("init");
export const patientFollowUpsErrorAtom = atom<AtomError>(null);
export const currentFollowUpAtom = atom<FollowUpWithPatient | null>(null);
export const currentFollowUpStatusAtom = atom<AtomStatus>("init");
export const currentFollowUpErrorAtom = atom<AtomError>(null);
export const currentFollowUpUpdatingAtom = atom<boolean>(false);

/**
 * Public atom: Patient follow-ups
 */
export const patientFollowUpsAtom = atom<FollowUp[]>((get) => {
  return get(_apiPatientFollowUpsAtom);
});
